import { cn } from '@/lib/utils'

interface Props {
  name: string
}

export const CellContentApplicant = ({ name }: Props) => {
  return <div className={cn('flex items-center gap-2', 'whitespace-nowrap')}>{name || '-'}</div>
}
